module.exports = __webpack_public_path__ + "static/media/fx.16b7e428.svg";